import React from "react";
import { Drawer } from 'antd'



import Banners from "./Banners";
import Transactions from "./Transactions";
import Balance from "./Balance";
import Exchange from "./Exchange";
import WhatsAppNumbers from "./WhatsAppNumbers";
import ScrollToTop from "./scrollToTop";
import { connect } from 'react-redux'
import { rightMenuToggle } from 'store/actions/home'
import { useActions } from '../../../../hooks/useActions'

const DrawerRightSide: React.FC<any> = ({rightMenuStatus}) => {

    const { rightMenuToggle} = useActions()
    const closeRightMenu = () => {
        rightMenuToggle()
    }

    return (

        <Drawer
            title={false}
            placement="right"
            onClose={closeRightMenu}
            visible={rightMenuStatus}
            width={270}
            closable={false}
            className={'setting_drawer'}
        >
            <Banners />

            <Transactions />

            <Balance />

            <Exchange />

            <WhatsAppNumbers />

            <ScrollToTop />
        </Drawer>
    )
}

const mapDispatchToProps = { rightMenuToggle }

const mapStateToProps = (state: any) => ({
    rightMenuStatus: state.home.rightMenuStatus
})


export default connect(mapStateToProps, mapDispatchToProps)(DrawerRightSide)